<template>
  <v-app>
    <v-navigation-drawer app permanent class="elevation-0" width="240">
      <SidebarNav/>
    </v-navigation-drawer>

    <v-main class="main-slot">
      <v-container fluid class="dashboard-layout pa-0">
        <router-view/>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import SidebarNav from '@/components/SidebarNav.vue';

export default {
  name: 'DashboardLayout',
  components: { SidebarNav },
  mounted() {
    if (this.$route.query.loginSuccess === '1') {
      this.$store.dispatch('ui/showNotification', {
        type: 'success',
        message: 'Successfully logged in!',
      }, { root: true });
      this.$router.replace({ path: this.$route.path, query: {} });
    }
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/variables.scss';
@import '../styles/colors.scss';

.main-slot {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  height: 100%;
}

.dashboard-layout {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 100%;
  width: 100%;
  max-width: 100%;

  /* Sayfa kök elemanı — layout + gri zemin (view’larda *-container / *-wrapper tekrarına gerek yok) */
  > * {
    flex: 1;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    width: 100%;
    background-color: $light-surface-1;
  }
}

</style>
